import React from 'react';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';

export const defaultDirs: {
  [path: string]: MicrosoftGraph.DriveItem[];
} = {};

export default React.createContext(defaultDirs);
